import { createStore } from "hooksy";

interface State {
  vipId: any;
}

const defaultValue: State = { vipId: 0 };

export const [useVIPStore] = createStore(defaultValue);
